import React from 'react';
import { Printer, Zap, ShieldCheck, Lock, ArrowRight } from 'lucide-react';
import { Button, Badge } from './ui';
import { MOCKUP_URL } from '../data/kit';
export function Hero() {
  return <section className="bg-cream-50 min-h-screen min-h-[100svh] flex flex-col justify-center pt-2 pb-4 sm:pt-5 sm:pb-12 md:pt-8 md:pb-16 px-4" data-id="element-130" data-mp="9ka5uysjcswx">
      <div className="w-full max-w-5xl mx-auto text-center" data-id="element-131" data-mp="4na06ozlls6c">
        <div className="inline-flex items-center gap-1.5 sm:gap-2 mb-2 sm:mb-4" data-id="element-132" data-mp="12a0it4iflorg">
          <span className="text-base sm:text-xl" aria-hidden="true" data-id="element-133" data-mp="xanoxzt57hfd">⭐</span>
          <span className="text-rose-600 font-bold tracking-widest uppercase text-xs sm:text-sm" data-id="element-134" data-mp="x8bcg265lz9p">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="font-serif font-bold text-wine tracking-tight leading-[1.08] max-w-3xl mx-auto" data-id="element-135" data-mp="nb6mdr96tjnm">
          <span className="block text-[20px] sm:text-3xl md:text-[38px]" data-id="element-136" data-mp="3d2bkbqsid1w2">
            AYUDALO A AVANZAR
          </span>
          <span className="block text-[20px] sm:text-3xl md:text-[38px]" data-id="element-137" data-mp="3814cxsua24px">
            DE SÍLABAS Y PALABRAS
          </span>
          <span className="block text-rose-600 text-[24px] sm:text-4xl md:text-[48px] my-0.5 sm:my-1" data-id="element-138" data-mp="3o7lshs6gf8ph">
            A FRASES E HISTORIAS
          </span>
          <span className="block text-[20px] sm:text-3xl md:text-[38px]" data-id="element-139" data-mp="399jojgvigl7p">
            EN 30 DÍAS
          </span>
        </h1>

        <div className="mt-3 mb-3 sm:mt-6 sm:mb-6 flex justify-center" data-id="element-140" data-mp="3ebisosz2rm5p">
          <img src={MOCKUP_URL} alt="Kit Desafío Lector — 3 módulos + 5 bonos · Material digital e imprimible" className="w-full max-w-[318px] sm:max-w-[460px] h-auto mx-auto px-2 sm:px-6" width={1300} height={1200} loading="eager" fetchPriority="high" decoding="async" data-id="element-141" data-mp="30h9dxygpedpx" />
        </div>

        <p className="font-serif text-rose-600 font-bold tracking-tight leading-tight text-[17px] sm:text-2xl md:text-[26px] max-w-xl mx-auto" data-id="element-142" data-mp="2hk886bfbs9kx">
          UN CAMINO CLARO PARA LEER MEJOR DESDE CASA
        </p>

        <p className="text-ink-muted max-w-md mx-auto text-[14px] sm:text-base leading-snug sm:leading-relaxed mt-1.5 mb-3.5 sm:mt-3 sm:mb-6" data-id="element-143" data-mp="s3mcg0c5huxb">
          Si se traba, se frustra o evita leer, acompañalo paso a paso con
          actividades progresivas.
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 sm:gap-2 mb-4 sm:mb-7" data-id="element-144" data-mp="ddnfg0wc0pjf">
          <Badge className="whitespace-nowrap px-2 py-0.5 text-[11px] sm:px-3 sm:py-1 sm:text-xs" data-id="element-145" data-mp="1b0ni7ndj3z2b">
            <span className="mr-1 sm:mr-1.5" aria-hidden="true" data-id="element-146" data-mp="1622kbulr1rh1">📚</span> 3 Módulos + 5 Bonos
          </Badge>
          <Badge className="whitespace-nowrap px-2 py-0.5 text-[11px] sm:px-3 sm:py-1 sm:text-xs" data-id="element-147" data-mp="1126mye7k4yag">
            <Printer className="w-3.5 h-3.5 mr-1 sm:mr-1.5 text-rose-500" data-id="element-148" data-mp="x1nxurx1u6by" /> Material Imprimible
          </Badge>
          <Badge className="whitespace-nowrap px-2 py-0.5 text-[11px] sm:px-3 sm:py-1 sm:text-xs" data-id="element-149" data-mp="3lu0454qihb1b">
            <Zap className="w-3.5 h-3.5 mr-1 sm:mr-1.5 text-rose-500" data-id="element-150" data-mp="3hqaian1817jz" /> Acceso inmediato
          </Badge>
        </div>

        <div className="flex flex-col items-center gap-3 sm:gap-5" data-id="element-151" data-mp="1xaw06rmvemay">
          <Button size="md" className="w-full max-w-xl group leading-snug text-center px-5 sm:px-6 py-3.5 sm:py-3.5 text-[16px] sm:text-[15px] sm:whitespace-nowrap" onClick={() => document.getElementById('planes')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-152" data-mp="21a4t5ua36g5g">
            <span data-id="element-153" data-mp="2kyvntiovxwlb">
              <span className="block sm:inline" data-id="element-154" data-mp="2kyduouxiryhm">QUIERO AYUDARLO</span>{' '}
              <span className="block sm:inline" data-id="element-155" data-mp="2l0qbh4rjk2t3">A LEER MEJOR</span>
            </span>
            <ArrowRight className="hidden sm:block ml-2 w-5 h-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-156" data-mp="2oye7yc8vu3n3" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-x-4 sm:gap-x-6 gap-y-1 sm:gap-y-2 text-xs sm:text-sm text-ink-muted" data-id="element-157" data-mp="unixf4e50eho">
            <span className="flex items-center" data-id="element-158" data-mp="zndr1fpari6f">
              <ShieldCheck className="w-4 h-4 mr-1 text-sage-600" data-id="element-159" data-mp="4acnpgwqpx9j" /> Garantía 7 días
            </span>
            <span className="flex items-center" data-id="element-160" data-mp="3vgnjaxize5th">
              <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-161" data-mp="3vk1n8a7amn31" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-162" data-mp="e77jhs1mpjk4">
              <Zap className="w-4 h-4 mr-1 text-rose-500" data-id="element-163" data-mp="9bigtfubbmjl" /> Acceso inmediato
            </span>
          </div>
        </div>
      </div>
    </section>;
}